import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../Context/MyContext";
import { formatMessage } from "../../Utils/carSpecValue";
import "./CompareBar.css";

export default function CompareBar() {
  const navigate = useNavigate();
  const { compareIds, compare_page, clearCompare } = useContext(MyContext);
  const bar = compare_page.bar || {};

  if (!compareIds.length) return null;

  return (
    <div className="compare-bar">
      <div className="compare-bar-inner">
        <span className="compare-bar-label">
          {formatMessage(bar.label, { count: compareIds.length })}
        </span>
        <div className="compare-bar-actions">
          <button type="button" className="compare-bar-clear" onClick={clearCompare}>
            {bar.clearLabel}
          </button>
          <button
            type="button"
            className="compare-bar-go"
            onClick={() => navigate("/compare")}
          >
            {bar.compareLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
